module.exports = __webpack_public_path__ + "static/media/ic_btm_sheet_high_returns.236af64d.svg";